<section class="section-card-content">
  <form [formGroup]="debitAndCreditCardForm">
    <div >
      <p class="label tw-text-[16px]" data-cy="card-deposit-amount-text">{{ 'ui.funding.deposit.amount' | translate: 'Deposit Amount' }}</p>
      <div class="amount-row tw-relative">

        <!-- Message section -->
        <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

          <!-- Required -->
          <span
            class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
            *ngIf="formVal['amount'] && formVal['amount']?.errors
              && (formVal['amount'].touched || formVal['amount'].dirty)"
            data-cy="card-deposit-amount-error"
          >
            {{
              formVal['amount']?.errors?.['min']
                ? ('ui.funding.deposit.min.25' | translate: 'Cannot deposit less than $25.')
                : formVal['amount']?.errors?.['max']
                  ? ('ui.funding.deposit.max.500' | translate: 'Cannot deposit greater than $500.')
                  : ('ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.')
            }}
          </span>
        </span>

        <input
          formControlName="amount"
          id="depositAmount"
          (keyup)="depositAmount()"
          type="number"
          min="25"
          max="500"
          class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
          placeholder="25"
          pattern="^\d+(\.\d{1,2})?$"
          amwager3DecimalInput
          data-cy="card-deposit-input"
        />
      </div>
      <div class="tw-flex tw-mt-[6px] tw-mb-[22px] tw-justify-between">
        <span
          (click)="chooseAmount(500.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-500"
        >
          $500
        </span>
        <span
          (click)="chooseAmount(200.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-200"
        >
          $200
        </span>
        <span
          (click)="chooseAmount(100.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-100"
        >
          $100
        </span>
        <span
          (click)="chooseAmount(50.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-50"
        >
          $50
        </span>
        <span
          (click)="chooseAmount(25.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="card-deposit-25"
        >
          $25
        </span>
      </div>

      <p class="deposit-amount tw-text-[16px]" data-cy="card-deposit-number">
        {{ 'account.funding.deposit.credit.depo' | translate: 'Deposit:' }}<span class="tw-pl-[13px]">${{ (amount | number:'1.2') || '0.00' }}</span>
      </p>
      <p class="card-fee tw-text-[16px]" data-cy="card-deposit-fee">
        {{ 'account.funding.deposit.credit.cardfee' | translate: 'Card Fee:' }}<span class="tw-pl-[4px]">${{ (fee | number:'1.2') || '0.00' }}</span>
      </p>

      <div class="mid-line"></div>

      <p class="tw-text-[19px] tw-mb-[22px]">
        <span class="total-amount" data-cy="card-deposit-total-text">{{ 'generic.total' | translate: 'Total:' }}</span>
        <span class="tw-font-bold" data-cy="card-deposit-total-number">
          ${{ (total | number:'1.2') || '0.00' }}
        </span>
      </p>


      <div class="card-container">
        <div class="card-item tw-text-right" *ngIf="!showAddCard">
          <button
            (click)="showAddCardFn(true)"
            class="add-card active tw-w-[96px] tw-h-[41px] tw-text-[16px]"
            data-cy="card-deposit-add"
          >
            {{ 'generic.add' | translate: '+ Add' }}
          </button>
        </div>

        <div class="card-item tw-text-right" *ngIf="showAddCard">
          <button
            (click)="showAddCardFn(false)"
            class="add-card active tw-w-[96px] tw-h-[41px] tw-text-[16px]"
            data-cy="card-deposit-close"
          >
            {{ 'generic.close' | translate: 'Close' }}
          </button>
        </div>

        <feature-mat-add-account-card
          [hidden]="!showAddCard"
          [showAddCard]="showAddCard"
          (showAddCardFn)="showAddCardFn($event)"
        ></feature-mat-add-account-card>

      </div>

      <div class="card-content">

        <p class="label tw-ml-[9px]" data-cy="card-deposit-list-text">{{ 'ui.funding.card.list' | translate: 'Card List' }}</p>
        <div class="card-list-container" data-cy="card-deposit-list-table">
          <div class="card-lists">
            <div *ngIf="(cards$ | async)| isEmpty" class="empty-account tw-pl-[8px] tw-pb-[20px]">
              {{ 'ui.funding.please.add.card.to.deposit' | translate: 'Please add card to deposit.' }}
            </div>

            <div
              *ngFor="let card of cards$ | async; let i = index"
              (click)="chooseCard($event, 'debitAndCreditCard', ('card-' + i), card.OrderId)"
              id="card-{{i}}"
              class="card-per-row tw-flex tw-w-full tw-justify-between tw-items-center"
            >
              <div class="tw-flex tw-items-center tw-w-[145px]">
                <span class="selector tw-flex"></span>
                <img
                  *ngIf="card.Type === 'VI'"
                  src="/assets/images/funding/visa_icon.png"
                  alt="{{ 'ui.funding.card.logo' | translate: 'card logo' }}"
                  class="card-logo tw-ml-[9px]"
                />
                <img
                  *ngIf="card.Type === 'MC'"
                  src="/assets/images/funding/mastercard_icon.png"
                  alt="{{ 'ui.funding.card.logo' | translate: 'card logo' }}" class="card-logo tw-ml-[9px]"
                />
                <span class="card-name tw-text-[13px] tw-text-[#000000] tw-font-bold tw-ml-[8px]">
                  {{ card.Type | cardName }}
                </span>
              </div>

              <div class="tw-flex">
                <span class="card-ending tw-text-[12px]">
                  ending
                  <span class="tw-font-bold tw-text-[#000000]">
                    {{ card.LastFour | cardNumEnd }}
                  </span>
                </span>
              </div>

              <div class="tw-flex">
                <span class="card-date tw-text-[12px]">
                  {{ card.ExpMonth | cardDate:  card.ExpYear }}
                </span>
              </div>

              <div class="tw-flex">
                <mat-icon
                  (click)="confirmRemoveCard(card.OrderId)"
                  class="delete-card tw-text-[20px] tw-t-[-2px] tw-relative">
                  delete_outline
                </mat-icon>
              </div>
            </div>
          </div>
        </div>

      </div>

      <button
        (click)="deposit()"
        [ngClass]="
          {'active': (amount && orderId && !awaitFee && !isDepositing && formVal['amount'].valid)}
        "
        [disabled]="!amount || !orderId || awaitFee || isDepositing || formVal['amount'].invalid"
        class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px]"
        data-cy="card-deposit-now-button"
      >
        {{ 'account.funding.deposit.now' | translate: 'Deposit Now' }}
      </button>
    </div>
  </form>
</section>
